import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {ProfilesService} from '../profiles.service/profiles.service';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {filter, map, switchMap, take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProfilesResolver implements Resolve<boolean> {

  constructor(private profilesService: ProfilesService,
              private oidcSecurityService: OidcSecurityService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    const profiles = this.profilesService.profilesSubject?.value;

    if (profiles) {
      return of(Boolean(profiles));
    }

    return this.oidcSecurityService.isAuthenticated$.pipe(
      filter((isAuthenticated) => isAuthenticated),
      take(1),
      switchMap(() => this.profilesService.getProfiles()),
      map((data) => Boolean(data)),
    );
  }
}
